<template>
    <modal id="create-permission">
        <template slot="title">Create Permission</template>
        <template slot="body">
            <field-input v-model="form.name" placeholder="Name"></field-input>
            <field-input v-model="form.label" placeholder="Label"></field-input>
        </template>
        <template slot="footer">
            <button type="button" class="btn btn-default" @click="closeModal('create-permission')">Cancel</button>
            <button type="button" class="btn btn-success" :disabled="form.isSubmitted" @click="save()" >Save</button>
        </template>
    </modal>
</template>
<script>
    export default {

        props:{
            permissions:{
                type: Array,
                required:true,
            }
        },

        data () {
            return {
                form: new Form({
                    name: '',
                    label: ''
                })
            }
        },

        methods: {
            save(){
                this.form.post('/management/permissions', this.permission).then(response => {
                    this.permissions.unshift(response);
                    this.closeModal('create-permission')
                }).catch(error => {
                    Alert.error(error.first())
                });
            },
        },
    }
</script>
